export default __webpack_public_path__ + "static/media/trashButton.0ccca568.svg";